// extracted by mini-css-extract-plugin
export var hand1 = "home-module--hand1--gbULf";
export var hand2 = "home-module--hand2--7RND6";
export var flexcontainer = "home-module--flexcontainer--yLZKQ";
export var flexitemleft = "home-module--flexitemleft---XgFm";
export var flexitemright = "home-module--flexitemright--qoQ96";
export var header = "home-module--header--yqOgg";
export var btn = "home-module--btn--K39-2";